import { Services } from "./services";
import { ServicesCarousel } from "./services-carousel";
import { ServicesCompact } from "./services-compact";
import { ServicesExpandable } from "./services-expandable";
import type { ServicesProps } from "./services";

/** Layouts drawn by their own component; Grid and List are the Services component's. */
const LAYOUT_COMPONENTS = {
  carousel: ServicesCarousel,
  compact: ServicesCompact,
  expandable: ServicesExpandable,
} as const;

/**
 * The section for its layout.
 * @param {string} id The section id.
 * @param {ServicesProps} props The resolved props.
 * @returns {React.JSX.Element} The section.
 */
const renderLayout = (id: string, props: ServicesProps): React.JSX.Element => {
  // Sections saved before the layout field existed have none; they draw as the grid.
  const layout: string | undefined = props.layout;
  if (layout === "carousel" || layout === "compact" || layout === "expandable") {
    const Layout = LAYOUT_COMPONENTS[layout];
    return <Layout id={id} {...props} />;
  }
  return <Services id={id} {...props} />;
};

export { renderLayout };
